import React from 'react';
import { Outlet } from 'react-router-dom';
import RouteBar from './RouteBar'; // Adjust path as needed

function PipelineLayout() {
  return (
    <div className="flex flex-col min-h-screen bg-gray-100"> {/* FIXED: h-screen + overflow-hidden to cap at viewport */}
      <RouteBar /> {/* Sticky top, unchanged */}
      <main className="flex-1 pt-16"> {/* FIXED: flex-1 + overflow-auto; pt-16 offsets RouteBar */}
        <Outlet /> {/* Sub-views: UploaderApp, MemberUsageLog, etc. */}
      </main>
    </div>
  );
}

export default PipelineLayout;
